import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {
   ISFTPActivityReportParameters,
   SFTPActivityReportParameters,
} from 'types/diplomat/reports/SFTPActivityReportParameters';
import Panel from 'components/Panel';
import {Box, Grid} from '@mui/material';
import FormikRadioButton from 'components/inputs/FormikRadioButton';
import FormikCheckbox from 'components/inputs/FormikCheckbox';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {useFieldValue} from 'components/hook-form/useFieldValue';
import FormikSwitchValuable from 'components/inputs/FormikSwitchValueable';
import {enums} from 'types/enums';
import {ByDateReportTypeFormPart} from 'features/layout/DialogRoutes/dialogs/reports/parts/ByDateReportTypeFormPart';

type Props = {
   onClose: () => void;
   values?: ISFTPActivityReportParameters;
   onSubmit: (
      values: ISFTPActivityReportParameters,
      bag: FormOnSubmitHelpers<ISFTPActivityReportParameters>
   ) => void;
};
export const SFTPActivityReportForm = memo(({onClose, values, onSubmit}: Props) => {
   const params = values || {
      allRecords: false,
      byDate: true,
      relativeDate: true,
      relativeDateType: enums.TimeRangeReportType.enum.THIS_MONTH,
   };

   return (
      <Formik
         initialValues={SFTPActivityReportParameters.cast(params)}
         validationSchema={SFTPActivityReportParameters}
         onSubmit={onSubmit}
         initialTouched={['allRecords']}
      >
         <UserActivityReport onClose={onClose} />
      </Formik>
   );
});

function UserActivityReport({onClose}: {onClose: () => void}) {
   const {t} = useTranslation();
   const enabled = !useFieldValue<ISFTPActivityReportParameters>('allRecords');
   const byUserId = useFieldValue<ISFTPActivityReportParameters>('byUserId');
   const byUserIp = useFieldValue<ISFTPActivityReportParameters>('byUserIp');
   const byDate = useFieldValue<ISFTPActivityReportParameters>('byDate');

   return (
      <>
         <Panel>
            <Grid container spacing={3}>
               <Grid item sm={12}>
                  <FormikRadioButton
                     name="allRecords"
                     key="allRecordsTrue"
                     value={true}
                     label={t('Select All Records')}
                  />
               </Grid>
            </Grid>
            <Grid container spacing={3}>
               <Grid item sm={12}>
                  <FormikRadioButton
                     name="allRecords"
                     key="allRecordsFalse"
                     value={false}
                     label={t('Select Records')}
                  />
               </Grid>
            </Grid>
            <Box marginLeft={8}>
               <Grid container spacing={3}>
                  <Grid item sm={3}>
                     <FormikCheckbox
                        name="byUserId"
                        label={t('By User ID containing:')}
                        disabled={!enabled}
                     />
                  </Grid>
                  <Grid item sm={8}>
                     <FormikTextField
                        name="userId"
                        disabled={!enabled || !byUserId}
                        // height="230px"
                     />
                  </Grid>
               </Grid>
               <Grid container spacing={3}>
                  <Grid item sm={3}>
                     <FormikCheckbox
                        name="byUserIp"
                        label={t('By User IP Address containing:')}
                        disabled={!enabled}
                     />
                  </Grid>
                  <Grid item sm={8}>
                     <FormikTextField
                        name="userIp"
                        disabled={!enabled || !byUserIp}
                        // height="230px"
                     />
                  </Grid>
               </Grid>
               <Grid container spacing={3}>
                  <ByDateReportTypeFormPart />
               </Grid>
            </Box>
         </Panel>
         <Box
            sx={{
               margin: '0 auto',
               width: '18rem',
            }}
         >
            <FormikSwitchValuable
               name="_format"
               options={[enums.reportFormats.options[0], enums.reportFormats.options[1]]}
            />
         </Box>
         <FormFooterButtons cancel={onClose} />
         {/* {JSON.stringify(values)} */}
      </>
   );
}
